<template>
  <div class="vh-100 d-flex justify-content-center align-items-center">
    <transition name="fade-up">
      <div
        class="message-container"
        v-if="show"
      >
        <div class="card">
          <div class="card-header">
            <div
              class="icon-block text-center text-info"
            >
              <i
                class="fa fa-info"
              ></i>
            </div>
          </div>
          <div class="card-body text-muted">
            {{ $t('sentence.own_commercial') }}
          </div>
          <div
            class="card-footer d-flex justify-content-end"
          >
            <div class="mr-3">
              <v-button
                icon="line-chart"
                text="phrase.to_organisation_dashboard"
                :route-to="{name: 'organisation-dashboard'}"
                style-type="secondary"
              />
            </div>
            <v-button
              icon="columns"
              text="phrase.continue_reviewing"
              :route-to="{name: 'dashboard'}"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';

export default {
  name: 'OwnCommercialMessage',
  data() {
    return {
      show: false,
    };
  },
  components: {
    'v-button': Button,
  },
  created() {
    setTimeout(() => {
      this.show = true;
    }, 1);
  },
};
</script>

<style>
.message-container {
  max-width: 95%;
}

@media (min-width: 767px) {
  .message-container {
    max-width: 50%;
  }
}

.icon-block {
  font-size: 40px;
}
</style>
